import React from 'react';
import './fullscreen.scss';
import './card.scss';


function PhotoCard(props: any) {
  return (
    <div className={'card fullscreen-wrapper card-' + props.color}>
      <a href='http://palingen.effy.me' target='_blank' rel='noreferrer'>
        <div className='fullscreen' style={{ backgroundImage: 'url(' + props.image + ')' }}>
          <img src={props.image} alt='' />
        </div>

        <div className='card-body'>
          <h4 className='card-category'>{props.category}</h4>

          <div className='card-head'>
            <h3 className='card-title'>
              <span className='text'>{props.title}</span>
              <i className='icn-slide-right'></i>
            </h3>

            <h4>{props.description}</h4>
          </div>
        </div>
      </a>
    </div>
  );
}

export default PhotoCard;
